import getOne from 'utils/getOne'
import getRows from '../utils/getRows'
import { useEffect } from 'react'
import { apiUrls } from 'consts'

interface useInitFilterSyncLogDetailsProps {
  id: string
  filterId: string
  setRows: Function
  setFilterName: Function
  setShowOverlay: Function
}

const useInit = (props: useInitFilterSyncLogDetailsProps) => {
  useEffect(() => {
    getOne(apiUrls.filters, props.filterId).then((filterData: any) => {
        props.setFilterName(filterData.name)
    })
    getRows({
      id: props.id,
      filterId: props.filterId
    }).then((data: any) => {
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [])
}

export default useInit
